import React from 'react';

export const chargingRseeReportListColumns = [
  {
    title: 'ردیف',
    isRowNumber: true,
  },
  {
    title: 'تاریخ',
    dataIndex: 'date',
    name: 'date',
    isSortable: true,
  },
  {
    title: 'نام و نام خانوادگی',
    dataIndex: 'fullName',
    name: 'fullName',
    isSortable: false,
  },
  {
    title: 'مبلغ پرداخت شده',
    dataIndex: 'amount',
    name: 'amount',
    isSortable: false,
    render: amount => (
      <div className={`direction-ltr`}>{Number(amount).toLocaleString()}</div>
    ),
  },
  {
    title: 'تعداد آرسی شارژ شده',
    dataIndex: 'boughtRsee',
    name: 'boughtRsee',
    isSortable: false,
  },
  {
    title: 'تعداد آرسی از قبل',
    dataIndex: 'previousRsee',
    name: 'previousRsee',
    isSortable: false,
  },
  {
    title: 'تعداد کل آرسی',
    dataIndex: 'remainingRsee',
    name: 'remainingRsee',
    isSortable: false,
  },
];